<template>
  <svg
    width="125"
    height="24"
    viewBox="0 0 125 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.9752 2.07656C11.3944 1.22713 12.6056 1.22713 13.0248 2.07656L15.2608 6.60711C15.4273 6.94441 15.7491 7.17821 16.1213 7.2323L21.1211 7.9588C22.0585 8.09502 22.4328 9.24698 21.7544 9.90817L18.1366 13.4347C17.8672 13.6973 17.7443 14.0756 17.8079 14.4463L18.662 19.4258C18.8221 20.3595 17.8422 21.0714 17.0037 20.6306L12.5318 18.2796C12.1989 18.1046 11.8011 18.1046 11.4682 18.2796L6.99626 20.6306C6.15783 21.0714 5.17791 20.3595 5.33803 19.4258L6.19209 14.4463C6.25568 14.0756 6.13277 13.6973 5.86341 13.4347L2.24555 9.90817C1.56725 9.24699 1.94154 8.09502 2.87894 7.9588L7.8787 7.2323C8.25094 7.17821 8.57273 6.94441 8.7392 6.60711L10.9752 2.07656Z"
      fill="url(#paint0_radial_24107_1373)"
    />
    <path
      d="M35.5562 1.9635C35.9822 1.13954 37.1606 1.13954 37.5866 1.96351L39.9942 6.62009C40.1647 6.94983 40.4847 7.17622 40.8524 7.22722L46.1453 7.96137C47.0992 8.09368 47.4718 9.2741 46.7668 9.93008L43.0061 13.4292C42.7215 13.694 42.5911 14.0854 42.6598 14.468L43.5568 19.4602C43.7233 20.3868 42.7608 21.106 41.9194 20.6838L37.084 18.2572C36.7615 18.0954 36.3814 18.0954 36.0588 18.2572L31.2235 20.6838C30.3821 21.106 29.4196 20.3868 29.586 19.4602L30.483 14.468C30.5518 14.0854 30.4213 13.694 30.1367 13.4292L26.376 9.93008C25.671 9.2741 26.0437 8.09368 26.9975 7.96137L32.2905 7.22722C32.6581 7.17622 32.9782 6.94983 33.1486 6.62009L35.5562 1.9635Z"
      fill="url(#paint1_radial_24107_1373)"
    />
    <path
      d="M60.1177 2.07656C60.537 1.22713 61.7482 1.22713 62.1674 2.07656L64.4034 6.60711C64.5699 6.94441 64.8916 7.17821 65.2639 7.2323L70.2636 7.9588C71.201 8.09502 71.5753 9.24698 70.897 9.90817L67.2792 13.4347C67.0098 13.6973 66.8869 14.0756 66.9505 14.4463L67.8045 19.4258C67.9647 20.3595 66.9847 21.0714 66.1463 20.6306L61.6744 18.2796C61.3415 18.1046 60.9437 18.1046 60.6108 18.2796L56.1388 20.6306C55.3004 21.0714 54.3205 20.3595 54.4806 19.4258L55.3347 14.4463C55.3983 14.0756 55.2753 13.6973 55.006 13.4347L51.3881 9.90817C50.7098 9.24699 51.0841 8.09502 52.0215 7.9588L57.0213 7.2323C57.3935 7.17821 57.7153 6.94441 57.8818 6.60711L60.1177 2.07656Z"
      fill="url(#paint2_radial_24107_1373)"
    />
    <path
      d="M84.6988 1.9635C85.1248 1.13954 86.3032 1.13954 86.7292 1.96351L89.1368 6.62009C89.3073 6.94983 89.6273 7.17622 89.995 7.22722L95.2879 7.96137C96.2418 8.09368 96.6144 9.2741 95.9094 9.93008L92.1487 13.4292C91.8641 13.694 91.7336 14.0854 91.8024 14.468L92.6994 19.4602C92.8659 20.3868 91.9034 21.106 91.0619 20.6838L86.2266 18.2572C85.904 18.0954 85.524 18.0954 85.2014 18.2572L80.3661 20.6838C79.5246 21.106 78.5621 20.3868 78.7286 19.4602L79.6256 14.468C79.6944 14.0854 79.5639 13.694 79.2793 13.4292L75.5186 9.93008C74.8136 9.2741 75.1862 8.09368 76.1401 7.96137L81.433 7.22722C81.8007 7.17622 82.1207 6.94983 82.2912 6.62009L84.6988 1.9635Z"
      fill="url(#paint3_radial_24107_1373)"
    />
    <path
      d="M110.984 1.9635C111.41 1.13954 112.589 1.13954 113.015 1.96351L115.422 6.62009C115.593 6.94983 115.913 7.17622 116.281 7.22722L121.574 7.96137C122.527 8.09368 122.9 9.2741 122.195 9.93008L118.434 13.4292C118.15 13.694 118.019 14.0854 118.088 14.468L118.985 19.4602C119.152 20.3868 118.189 21.106 117.348 20.6838L112.512 18.2572C112.19 18.0954 111.81 18.0954 111.487 18.2572L106.652 20.6838C105.81 21.106 104.848 20.3868 105.014 19.4602L105.911 14.468C105.98 14.0854 105.85 13.694 105.565 13.4292L101.804 9.93008C101.099 9.2741 101.472 8.09368 102.426 7.96137L107.719 7.22722C108.086 7.17622 108.406 6.94983 108.577 6.62009L110.984 1.9635Z"
      fill="#C1C1C5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M113.143 2.48922C113.143 2.30657 113.099 2.12649 113.016 1.96425C112.59 1.14028 111.411 1.13963 110.985 1.96359L108.577 6.62018C108.407 6.94991 108.087 7.17631 107.719 7.22731L102.426 7.96146C101.472 8.09376 101.1 9.27418 101.805 9.93017L105.565 13.4293C105.85 13.6941 105.98 14.0855 105.912 14.4681L105.015 19.4603C104.848 20.3869 105.811 21.1061 106.652 20.6839L111.73 18.1357C111.9 18.0504 112.1 18.0504 112.27 18.1357C112.671 18.3368 113.143 18.0455 113.143 17.5971V2.48922Z"
      fill="url(#paint4_radial_24107_1373)"
    />
    <defs>
      <radialGradient
        id="paint0_radial_24107_1373"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(12 12) rotate(90) scale(12)"
      >
        <stop stop-color="#717FFF" />
        <stop
          offset="1"
          stop-color="#5061FA"
        />
      </radialGradient>
      <radialGradient
        id="paint1_radial_24107_1373"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(36.5714 12) rotate(90) scale(12 12.5714)"
      >
        <stop stop-color="#717FFF" />
        <stop
          offset="1"
          stop-color="#5061FA"
        />
      </radialGradient>
      <radialGradient
        id="paint2_radial_24107_1373"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(61.1426 12) rotate(90) scale(12)"
      >
        <stop stop-color="#717FFF" />
        <stop
          offset="1"
          stop-color="#5061FA"
        />
      </radialGradient>
      <radialGradient
        id="paint3_radial_24107_1373"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(85.714 12) rotate(90) scale(12 12.5714)"
      >
        <stop stop-color="#717FFF" />
        <stop
          offset="1"
          stop-color="#5061FA"
        />
      </radialGradient>
      <radialGradient
        id="paint4_radial_24107_1373"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(113.143 12.0002) rotate(123.601) scale(10.5744 6.35921)"
      >
        <stop stop-color="#717FFF" />
        <stop
          offset="1"
          stop-color="#5061FA"
        />
      </radialGradient>
    </defs>
  </svg>
</template>
